import React, { useState, useEffect } from 'react';
import { FaPhone, FaPlay, FaPause } from 'react-icons/fa';

function Home() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Stories data - based on real projects
  const stories = [
    {
      id: 1,
      title: "מסעדת פסטה בסטה",
      image: "/images/pasta-basta/future/IMG_3619.webp",
      video: "https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971816/IMG_3876_xvkci7.mp4",
      duration: 15000
    },
    {
      id: 2,
      title: "פנטהאוס גורדון - נתניה",
      image: "/images/gordon-penthouse/after/IMG_0779.webp",
      video: "https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971830/IMG_0947_iqs1k8.mp4",
      duration: 15000
    },
    {
      id: 3,
      title: "חדר הרב - בית כנסת",
      image: "/images/harav-netanya/after/IMG_3098.webp",
      video: "https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971809/2ba98106-7a84-4af4-909c-d6f7715fd1b2_ntumrn.mp4",
      duration: 15000
    },
    {
      id: 4,
      title: "בית פרטי - כפר תבור",
      image: "/images/kfar-tavor/after/IMG_2808.webp",
      video: "https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971820/IMG_2826_fs5dbo.mp4",
      duration: 15000
    },
    {
      id: 5,
      title: "דירת קבלן - מלכת שבא",
      image: "/images/malkat-shva/after/IMG_2436.webp",
      video: "https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971813/IMG_2479_dcljov.mp4",
      duration: 15000
    }
  ];

  // Stories state
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showStoryModal, setShowStoryModal] = useState(false);
  const [progress, setProgress] = useState(0);

  // Auto play story
  useEffect(() => {
    if (!showStoryModal || !isPlaying) return;

    const currentStory = stories[currentStoryIndex];
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          // Move to next story
          if (currentStoryIndex < stories.length - 1) {
            setCurrentStoryIndex(prev => prev + 1);
            return 0;
          } else {
            // End of stories
            setShowStoryModal(false);
            setIsPlaying(false);
            setCurrentStoryIndex(0);
            return 0;
          }
        }
        return prev + (100 / (currentStory.duration / 100));
      });
    }, 100);

    return () => clearInterval(interval);
  }, [showStoryModal, isPlaying, currentStoryIndex, stories]);

  const openStory = (index) => {
    setCurrentStoryIndex(index);
    setShowStoryModal(true);
    setIsPlaying(true);
    setProgress(0);
  };

  const closeStory = () => {
    setShowStoryModal(false);
    setIsPlaying(false);
    setProgress(0);
    setCurrentStoryIndex(0);
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const nextStory = () => {
    if (currentStoryIndex < stories.length - 1) {
      setCurrentStoryIndex(prev => prev + 1);
      setProgress(0);
    } else {
      closeStory();
    }
  };

  const prevStory = () => {
    if (currentStoryIndex > 0) {
      setCurrentStoryIndex(prev => prev - 1);
      setProgress(0);
    }
  };

  return (
    <div>
      {/* Stories Section */}
      <div className="stories-section">
        <div className="stories-container">
          {stories.map((story, index) => (
            <div
              key={story.id}
              className="story-item"
              onClick={() => openStory(index)}
            >
              <div className="story-thumbnail">
                <img src={story.image} alt={story.title} />
                <div className="story-play-icon">
                  <FaPlay />
                </div>
              </div>
              <span className="story-title">{story.title}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Story Modal */}
      {showStoryModal && (
        <div className="story-modal" onClick={closeStory}>
          <div className="story-content" onClick={(e) => e.stopPropagation()}>
            {/* Progress bars */}
            <div className="story-progress-container">
              {stories.map((_, index) => (
                <div key={index} className="story-progress-bar">
                  <div
                    className="story-progress-fill"
                    style={{
                      width: index === currentStoryIndex ? `${progress}%` :
                        index < currentStoryIndex ? '100%' : '0%'
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Story content */}
            <div className="story-image-container">
              {stories[currentStoryIndex]?.video?.startsWith('youtube:') ? (
                <iframe
                  key={currentStoryIndex}
                  className="story-video story-youtube"
                  src={`https://www.youtube.com/embed/${stories[currentStoryIndex]?.video.replace('youtube:', '')}?rel=0&modestbranding=1&controls=1&autoplay=1&mute=1&playsinline=1&enablejsapi=1`}
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              ) : stories[currentStoryIndex]?.video ? (
                <video
                  key={currentStoryIndex}
                  src={stories[currentStoryIndex]?.video}
                  autoPlay
                  playsInline
                  muted
                  loop
                  className="story-video"
                />
              ) : (
                <img
                  src={stories[currentStoryIndex]?.image}
                  alt={stories[currentStoryIndex]?.title}
                />
              )}

              {/* Navigation areas */}
              <div className="story-nav-left" onClick={prevStory}></div>
              <div className="story-nav-right" onClick={nextStory}></div>

              {/* Play/Pause button */}
              <div className="story-play-pause" onClick={togglePlayPause}>
                {isPlaying ? <FaPause /> : <FaPlay />}
              </div>

              {/* Close button */}
              <button className="story-close" onClick={closeStory}>✕</button>

              {/* Story title */}
              <div className="story-modal-title">
                <h3>{stories[currentStoryIndex]?.title}</h3>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Original Home Section */}
      <section className="home">
        <h1>ברוכים הבאים</h1>
        <div className="logo">
          <img src="/logo/logo.png" alt="לוגו בינה" />
          <div className="logo-text">בינה לבנייה</div>
        </div>
        <p className="home-welcome">המקום שבו הבנייה פוגשת את הניסיון והמקצועיות</p>
        <p className="home-description">חברת בניה המתמחה בביצוע פרויקטים מקצה לקצה – מהשלב ההתחלתי ועד מסירת המפתח, הן במגזר הפרטי והן במגזר המסחרי.</p>
        <div className="hero-stats">
          <div className="stat">
            <h3>10+</h3>
            <p>פרויקטים הושלמו</p>
          </div>
          <div className="stat">
            <h3>2+</h3>
            <p>שנות ניסיון</p>
          </div>
          <div className="stat">
            <h3>100%</h3>
            <p>שביעות רצון</p>
          </div>
        </div>
        <button className="cta-btn" onClick={scrollToContact}>
          צור קשר עכשיו <FaPhone style={{ marginLeft: '8px' }} />
        </button>
      </section>
    </div>
  );
}

export default Home;
